module.exports = __webpack_public_path__ + "static/fipcpinkblossom2-808852fc55984aed9b11f3a7defce717.jpeg";